export class OrganisationStatus {
    code: string;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/organisationStatus.ts